import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 上传头像
   */
  static uploadAvatar(data) {
    return request({
      url: 'user/info/uploadAvatar',
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 获取跳转链接
   */
  static getWechatLoginUrl(params) {
    return request({
      url: 'user/login/wechatLoginUrl',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否绑定企微用户
   */
  static queryUserBindWorkWechat(params) {
    return request({
      url: 'user/login/queryUserBind',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 绑定企微用户
   */
  static bindUserWorkWechat(params) {
    return request({
      url: 'user/login/bindUserCode',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 解绑企微用户
   */
  static secureWorkWechatBind(params) {
    return request({
      url: 'user/login/authUnBind',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 解绑谷歌账号
   */
  static unbindGoogle(params) {
    return request({
      url: 'user/binding/userCenter/unBindGoogle',
      host: config.HOST_MALL,
      method: 'post',
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/Account/AccountServ.js